import { has } from 'lodash';

const getShipping = (state, shippingType) => {
  const availableTypes = state.data.shipping?.availableShippingTypes || [];

  const shipping = availableTypes.find(
    (type) => type.shippingType === shippingType
  );

  return shipping;
};

export default {
  getAddresses(state) {
    if (has(state, ['data', 'address'])) {
      return state.data.address;
    }
    return { addresses: { billing: [], shipping: [] } };
  },
  getBillingAddresses(state) {
    if (has(state, ['data', 'address', 'addresses', 'billing'])) {
      const billing = state.data.address.addresses.billing || [];
      return billing.filter((a) => a && Object.keys(a).length);
    }
    if (has(state, ['data', 'selectedBillingAddress'])) {
      const selected = state.data.selectedBillingAddress;
      return selected && Object.keys(selected).length ? [selected] : [];
    }
    return [];
  },
  getShippingAddresses(state) {
    if (has(state, ['data', 'address', 'addresses', 'shipping'])) {
      return state.data.address.addresses.shipping;
    }
    if (has(state, ['data', 'selectedShippingAddress'])) {
      const selected = state.data.selectedShippingAddress;
      return selected && Object.keys(selected).length ? [selected] : [];
    }
    return [];
  },
  getSelectedShippingAddress(state) {
    if (has(state, ['data', 'selectedShippingAddress'])) {
      return state.data.selectedShippingAddress;
    }
    return {};
  },
  getSelectedBillingAddress(state) {
    if (has(state, ['data', 'selectedBillingAddress'])) {
      return state.data.selectedBillingAddress;
    }
    return {};
  },
  getInstantProductsPartialDeliveryPartOne: (state) => (shippingType) => {
    const shipping = getShipping(state, shippingType);
    return shipping?.partialDelivery?.instantlyAvailableProducts || [];
  },
  getLaterProductsPartialDeliveryPartTwo: (state) => (shippingType) => {
    const shipping = getShipping(state, shippingType);
    return shipping?.partialDelivery?.laterAvailableProducts || [];
  },
  getSelectedPartialDelivery(state, getters) {
    const type = getters.getSelectedShippingOption;
    if (!type) return null;

    const shipping = getShipping(state, type);
    return shipping ? shipping.partialDelivery : null;
  },
  getInstantProductsPartialDeliveryPartOneSelected(state, getters) {
    const type = getters.getSelectedShippingOption;
    if (!type) return { instantlyAvailableProducts: [] };

    const shipping = getShipping(state, type);
    return {
      instantlyAvailableProducts:
        shipping?.partialDelivery?.instantlyAvailableProducts || [],
    };
  },
  getLaterProductsPartialDeliveryPartTwoSelected(state, getters) {
    const type = getters.getSelectedShippingOption;
    if (!type) return { laterAvailableProducts: [] };

    const shipping = getShipping(state, type);
    return {
      laterAvailableProducts:
        shipping?.partialDelivery?.laterAvailableProducts || [],
    };
  },
  getCurrentStep(state) {
    return state.data.step;
  },
  getAvailablePayments(state) {
    return state.data?.payment?.availablePayments || [];
  },
  getSelectedPayment(state) {
    return {
      ...state.data.selectedPayment,
      additionalData:
        state.data.payment.selectedPayment &&
          state.data.payment.selectedPayment.additionalData
          ? state.data.payment.selectedPayment.additionalData
          : null,
    };
  },
  // [Mina] Should be removed
  getOriginalSelectedPayment(state) {
    return (
      state.data.payment?.selectedPayment || state.data?.selectedPayment || null
    );
  },
  getIsValidPaymentSelection(state) {
    return state.data.isValidPaymentSelection;
  },
  getRegularShippingCost(state) {
    const shipping = getShipping(state, 'shipment_regular');
    return shipping
      ? shipping.shippingCost
      : state.data?.cart?.amounts?.baseShipping || 0;
  },
  getExpressShippingCost(state) {
    const shipping = getShipping(state, 'shipment_express');
    return shipping
      ? shipping.shippingCost
      : state.data?.cart?.amounts?.baseShipping || 0;
  },
  getDirectDeliveryShippingCost(state) {
    const shipping = getShipping(state, 'direct_delivery');
    return shipping
      ? shipping.shippingCost
      : state.data?.cart?.amounts?.baseShipping || 0;
  },
  getRegularShippingDetails(state) {
    return getShipping(state, 'shipment_regular');
  },
  getExpressShippingDetails(state) {
    return getShipping(state, 'shipment_express');
  },
  getDirectDeliveryShippingDetails(state) {
    const shipping = getShipping(state, 'direct_delivery');
    return shipping ? shipping.partialDelivery : null;
  },
  getRegularPartialDelivery(state) {
    const shipping = getShipping(state, 'shipment_regular');
    return shipping ? shipping.partialDelivery : null;
  },
  getExpressPartialDelivery(state) {
    const shipping = getShipping(state, 'shipment_express');
    return shipping ? shipping.partialDelivery : null;
  },
  getDirectDeliveryPartialDelivery(state) {
    const shipping = getShipping(state, 'direct_delivery');
    return shipping ? shipping.partialDelivery : null;
  },
  getSelectedShippingOption(state) {
    return state.data.shipping?.shippingType;
  },
  getSelectedPartialShippingOption(state) {
    return state.data.shipping?.partialDelivery;
  },
  isDropShippingItems(state) {
    return state.data?.dropshippingItems || false;
  },
  isZipCodeNotAllowed(state) {
    if (state?.data?.shipping?.availableShippingTypes) {
      return state.data.shipping.availableShippingTypes.some(
        (item) => item.zipCodeAllowed === false
      );
    }
    return false;
  },
  getRefinedIdealBanksList(state) {
    const idealPaymentMethod =
      state.data?.payment?.availablePayments.find(
        (obj) => obj.name === 'ideal'
      ) ?? false;
    if (idealPaymentMethod) {
      let refinedBankList = [];

      Object.keys(
        idealPaymentMethod.additionalData.idealAvailableBanks
      ).forEach((key) => {
        refinedBankList.push({
          label: idealPaymentMethod.additionalData.idealAvailableBanks[key],
          value: key,
        });
      });

      return refinedBankList;
    }
    return [];
  },
  getPaypalPaymentConfirmation(state) {
    return state.data.paymentConfirmation;
  },
  getPaypalInstance(state) {
    return state.data.paypalInstance;
  },
  getOfferId(state) {
    return state.data?.offerId ?? null;
  },
  getProductQuantityByDisplaySku: (state) => (displaySku) => {
    if (!displaySku) return 0;

    if (
      has(state, ['data', 'cart', 'sections']) &&
      Array.isArray(state.data.cart.sections)
    ) {
      for (const section of state.data.cart.sections) {
        if (Array.isArray(section.products)) {
          const product = section.products.find(
            (p) => p.displaySku === displaySku
          );
          if (product) {
            return product.quantityAmount ?? 0;
          }
        }
      }
    }

    return 0;
  },
  getShippingSelected: (state) => (shippingType) => {
    return getShipping(state, shippingType);
  },
  getIsShippingSameAsBilling(state) {
    return state.data.isShippingSameAsBilling;
  },
};
